import { css } from '@emotion/css'
import { spacing, breakpoint, mediaQueryHelper } from '@offerzen/pinata'

const styles = {
  sideContent: css({
    order: 2,
    flex: '0 0 auto',
    width: '100%',

    [mediaQueryHelper(breakpoint.tablet)]: {
      order: 1,
      width: 'calc(100% - 280px)',
      paddingRight: spacing.large,
    },

    [mediaQueryHelper(breakpoint.desktop)]: {
      width: 'calc(100% - 320px)',
      paddingRight: spacing.large,
    },
  }),
}

export default styles
